import React, { forwardRef, useState, useImperativeHandle, useCallback, useRef } from 'react'
import { Spin } from 'antd'
import Empty from 'meinian-package/src/baseComponent/empty'
import Platform from 'component/filter/platform'
import Gender from 'component/filter/gender'
import Inspiration from 'component/filter/inspiration'
import useAsyncLoading from 'common/hooks/useAsyncLoading'
import request from 'meinian-package/src/utils/request'
import isIPad from 'meinian-package/src/common/isIPad'
import PieAttrChart, { SOURCE_TYPE } from '../../../component/pieAttrChart'
import styles from './index.module.less'

export default forwardRef(({ style,
  baseParams, isLink, isInspiration = true, onParentClick,
  menuOption, menuItemNameWidth = 140, disabled }, ref) => {
  const [params, setParams] = useState({})
  const paramsRef = useRef(null)
  paramsRef.current = params
  const memberContributeData = useAsyncLoading({ fetchData: (_params) => fetchData(_params), params: baseParams })

  useImperativeHandle(ref, () => ({
    ...memberContributeData
  }))

  const fetchData = async (_params) => {
    const result = await request.sget('/zhikuan/mn/collect-statistic/v2/collect-distribution', { ..._params }, 'collect_statistic_collect_distribution')
    return result
  }

  const transformData = useCallback((key) => {
    const _total = memberContributeData.data?.[key]?.items?.reduce((total, number) => {
      total += number.value
      return total
    }, 0)
    const _data = memberContributeData.data?.[key]?.items?.map(item => {
      item.name = item?.itemName
      item.id = item?.itemKey
      item.ratio = _total ? item.count / _total : 0
      return item
    })
    return {
      data: _data || [],
      total: _total
    }
  }, [memberContributeData.data])

  const collectStyleData = transformData('collectDistribution')

  const passStyleData = transformData('passDistribution')

  const _onChange = (valObj) => {
    setParams((pre) => ({ ...pre, ...valObj }))
    memberContributeData.onUpdate({ ...baseParams, ...paramsRef.current, ...valObj })
  }
  console.log('passStyleData', passStyleData)
  return (<div className={styles['meinian-member-contribute']} style={style}>
    <div className="meinian-member-contribute-header">
      <div className="meinian-member-contribute-title">成员贡献</div>
      <div className="meinian-member-contribute-right">
        <span style={{ marginRight: '16px' }}><Gender
          value={params?.gender}
          onChange={(val) => {
            _onChange({ gender: val })
          }}
        /></span>
        <span style={{ marginRight: `${isInspiration && '16px'}` }}>
          <Platform
            ulStyle={{ maxHeight: '300px' }}
            value={params?.platformIdList}
            onChange={(val) => _onChange({ platformIdList: val })}
          />
        </span>
        {isInspiration && <Inspiration value={params?.inspirationIdList} onChange={(val) => _onChange({ inspirationIdList: val })} />}
      </div>
    </div>
    <Spin spinning={memberContributeData.loading}>
      {
        // 采集款式存在才会有已经通过款式
        collectStyleData.data?.length ? <div className="meinian-member-contribute-chartGroup">
          <PieAttrChart
            onParentClick={onParentClick}
            data={collectStyleData.data}
            menuTitle={<span>采集款式&nbsp;&nbsp;{Number(collectStyleData.total).toLocaleString()}</span>}
            centerText="成员贡献占比"
            sourceType={isLink && SOURCE_TYPE.OTHER}
            isActive={false}
            markStatus={null}
            disabled={disabled}
            inspirationId={baseParams.inspirationId}
            style={{ width: '50%', flex: 1 }}
            menuOption={{ style: { maxHeight: '268px', width: '288px', ...menuOption?.style, }, menuItemNameWidth }}
            chartOption={{ style: { height: `${isIPad ? '240px' : '314px'}`, width: `${isIPad ? '240px' : '314px'}`, marginLeft: '0px' } }}
          />
          {
            !!passStyleData.data?.length && <PieAttrChart
              onParentClick={(val) => onParentClick(val, 'pass')}
              data={passStyleData.data}
              menuTitle={<span>已通过款式&nbsp;&nbsp;{Number(passStyleData.total).toLocaleString()}</span>}
              centerText="成员贡献占比"
              sourceType={isLink && SOURCE_TYPE.OTHER}
              isActive={false}
              disabled={disabled}
              markStatus={1}
              inspirationId={baseParams.inspirationId}
              style={{ width: '50%', flex: 1, marginLeft: '16px' }}
              menuOption={{ style: { maxHeight: '268px', width: '288px', ...menuOption?.style }, menuItemNameWidth }}
              chartOption={{ style: { height: `${isIPad ? '240px' : '314px'}`, width: `${isIPad ? '240px' : '314px'}`, marginLeft: '0px' } }}
            />
          }
        </div> : <Empty type="analysis" />
    }
    </Spin>
  </div>)
})
